import {
  SET_STEP,
  SET_ADDRESS,
  SET_PHONE_NUMBER,
  SET_SKILLS,
  SET_MEMBER_EQUIPMENTS,
  SET_MEMBER_PROFILE,
  SET_ORGANIZATION_STATUSES,
  SET_PRODUCT_TYPES,
  SET_PRODUCT_SUBTYPES,
  SET_ORGANIZATION_DOCUMENTS,
  SET_IDENTIFICATION_TYPES,
  SET_EQUIPMENTS,
  SET_LANGUAGES,
  SET_PRODUCT_SUBTYPES_LOADING,
} from './mutation-types';
import OperatorApplicationAPI from '~/services/api/OperatorApplicationAPI';
import OrganizationsAPI from '~/services/api/OrganizationsAPI';

/**
 * Create Member Address
 * @param {function} commit - The vuex commit function
 * @param {function} payload - memberId: member id // address: memeber address
 */
// eslint-disable-next-line
export async function createMemberAddress({ commit }, { payload }) {
  const createdMemberAddress = await OperatorApplicationAPI.createMemberAddress(payload);
  try {
    return Promise.resolve(createdMemberAddress);
  } catch (error) {
    return Promise.reject(error);
  }
}

/**
 * Update member phone
 * @param {object} state - the vuex state object
 * @param {object} payload - id: member id // phone: phone number
 */
// eslint-disable-next-line
export async function patchPhone({ state, commit }, payload) {
  try {
    const updatedPhone = await OperatorApplicationAPI.patchPhone(payload);
    return Promise.resolve(updatedPhone);
  } catch (error) {
    return Promise.reject(error);
  }
}

/**
 * Verify member phone
 * @param {object} state - the vuex state object
 * @param {object} payload - id: member id // code: verification code
 */
// eslint-disable-next-line
export async function verifyPhone({ state, commit }, payload) {
  try {
    const verifiedPhone = await OperatorApplicationAPI.verifyPhone(payload);
    return Promise.resolve(verifiedPhone);
  } catch (error) {
    return Promise.reject(error);
  }
}

/**
 * Fetch an Organization invitations list
 * @param {function} commit - The vuex commit function
 * @param {function} organizationId - The organization id
 */
 export async function fetchOrganizationPossibleLegalStatuses({ commit }, organizationId) {
  const statuses = await OrganizationsAPI.fetchOrganizationPossibleLegalStatuses(organizationId);
  try {
    if (statuses) {
      const { data } = statuses;
      commit(SET_ORGANIZATION_STATUSES, data);
    }
    return Promise.resolve(statuses);
  } catch (error) {
    return Promise.reject(error);
  }
}

/**
 * Fetch Product Types
 * @param {function} commit - The vuex commit function
 */
 export async function fetchProductTypes({ commit }) {
  const types = await OperatorApplicationAPI.fetchProductTypes();
  try {
    if (types) {
      const { data } = types;
      commit(SET_PRODUCT_TYPES, data);
    }
    return Promise.resolve(types);
  } catch (error) {
    return Promise.reject(error);
  }
}

/**
 * Fetch Product Subtypes
 * @param {function} commit - The vuex commit function
 */
 export async function fetchProductSubtypes({ commit }) {
  commit(SET_PRODUCT_SUBTYPES_LOADING, true);
  try {
    const subtypes = await OperatorApplicationAPI.fetchProductSubtypes();
    if (subtypes) {
      const { data } = subtypes;
      commit(SET_PRODUCT_SUBTYPES, data);
    }
    commit(SET_PRODUCT_SUBTYPES_LOADING, false);
    return Promise.resolve(subtypes);
  } catch (error) {
    commit(SET_PRODUCT_SUBTYPES_LOADING, false);
    return Promise.reject(error);
  }
}

/**
 * Upload an organization legal document
 * @param {object} state - the vuex state object
 * @param {object} payload - organizationId: organization id // documentId: document id // document: document file string
 */
// eslint-disable-next-line
export async function uploadLegalDocument({ state, commit }, payload) {
  try {
    const uploadedDoc = await OperatorApplicationAPI.uploadLegalDocument(payload);
    return Promise.resolve(uploadedDoc);
  } catch (error) {
    return Promise.reject(error);
  }
}

/**
 * Fetch Organization documents
 * @param {function} commit - The vuex commit function
 */
 export async function fetchOrganizationDocuments({ commit }, organizationId) {
  const documents = await OperatorApplicationAPI.fetchOrganizationDocuments(organizationId);
  try {
    if (documents) {
      const { data } = documents;
      commit(SET_ORGANIZATION_DOCUMENTS, data);
    }
    return Promise.resolve(documents);
  } catch (error) {
    return Promise.reject(error);
  }
}

/**
 * Fetch Identification types
 * @param {function} commit - The vuex commit function
 */
 export async function fetchIdentificationTypes({ commit }, organizationId) {
  const identifications = await OperatorApplicationAPI.fetchIdentificationTypes(organizationId);
  try {
    if (identifications) {
      const { data } = identifications;
      commit(SET_IDENTIFICATION_TYPES, data);
    }
    return Promise.resolve(identifications);
  } catch (error) {
    return Promise.reject(error);
  }
}

/**
 * Create an Organization billing infos
 * @param {function} commit - The vuex commit function
 * @param {function} payload - The organizationId, billing infos
 */
// eslint-disable-next-line
export async function createOrganizationBillingInfos({ commit }, { payload }) {
  const createdOrganizationBillingInfos = await OrganizationsAPI.createOrganizationBillingInfos(payload);
  try {
    return Promise.resolve(createdOrganizationBillingInfos);
  } catch (error) {
    return Promise.reject(error);
  }
}

/**
 * Update an Organization billing infos
 * @param {function} commit - The vuex commit function
 * @param {function} payload - The organizationId, billing infos
 */
// eslint-disable-next-line
export async function updateOrganizationBillingInfos({ commit }, { payload }) {
  const updatedOrganizationBillingInfos = await OrganizationsAPI.updateOrganizationBillingInfos(payload);
  try {
    return Promise.resolve(updatedOrganizationBillingInfos);
  } catch (error) {
    return Promise.reject(error);
  }
}

/**
 * Create an Organization identification
 * @param {function} commit - The vuex commit function
 * @param {function} payload - The organizationId, identification infos
 */
// eslint-disable-next-line
export async function createOrganizationIdentification({ commit }, { payload }) {
  const createdOrganizationIdentification = await OrganizationsAPI.createOrganizationIdentification(payload);
  try {
    return Promise.resolve(createdOrganizationIdentification);
  } catch (error) {
    return Promise.reject(error);
  }
}

/**
 * Update an Organization identification
 * @param {function} commit - The vuex commit function
 * @param {function} payload - The organizationId, identification infos
 */
// eslint-disable-next-line
export async function updateOrganizationIdentification({ commit }, { payload }) {
  const updatedOrganizationIdentification = await OrganizationsAPI.updateOrganizationIdentification(payload);
  try {
    return Promise.resolve(updatedOrganizationIdentification);
  } catch (error) {
    return Promise.reject(error);
  }
}

/**
 * Update Member skills
 * @param {object} payload - memberId: member id // subtypes: list of subtype ids
 */
// eslint-disable-next-line
export async function updateMemberSkills({ commit }, { payload }) {
  const updatedMemberSkills = await OperatorApplicationAPI.updateMemberSkills(payload);
  try {
    return Promise.resolve(updatedMemberSkills);
  } catch (error) {
    return Promise.reject(error);
  }
}

/**
 * Fetch Equipments
 * @param {function} commit - The vuex commit function
 */
 export async function fetchEquipments({ commit }) {
  const equipments = await OperatorApplicationAPI.fetchEquipments();
  try {
    if (equipments) {
      const { data } = equipments;
      commit(SET_EQUIPMENTS, data);
    }
    return Promise.resolve(equipments);
  } catch (error) {
    return Promise.reject(error);
  }
}

/**
 * Update Member equipment
 * @param {object} payload - memberId: member id // equipment: list of equipment ids
 */
// eslint-disable-next-line
export async function updateMemberEquipment({ commit }, { payload }) {
  const updatedMemberEquipment = await OperatorApplicationAPI.updateMemberEquipment(payload);
  try {
    return Promise.resolve(updatedMemberEquipment);
  } catch (error) {
    return Promise.reject(error);
  }
}

/**
 * Fetch Languages
 * @param {function} commit - The vuex commit function
 */
 export async function fetchLanguages({ commit }) {
  const languages = await OperatorApplicationAPI.fetchLanguages();
  try {
    if (languages) {
      const { data } = languages;
      commit(SET_LANGUAGES, data);
    }
    return Promise.resolve(languages);
  } catch (error) {
    return Promise.reject(error);
  }
}

/**
 * Update Member profile
 * @param {object} payload - memberId: member id // profile: member profile w/ bio and portfolio links
 */
// eslint-disable-next-line
export async function createMemberProfile({ commit }, { payload }) {
  const updatedMemberProfile = await OperatorApplicationAPI.createMemberProfile(payload);
  try {
    return Promise.resolve(updatedMemberProfile);
  } catch (error) {
    return Promise.reject(error);
  }
}

/**
 * Update Member spoken languages
 * @param {object} payload - memberId: member id // languages: list of languages ids
 */
// eslint-disable-next-line
export async function updateMemberLanguages({ commit }, { payload }) {
  const updatedMemberLanguages = await OperatorApplicationAPI.updateMemberLanguages(payload);
  try {
    return Promise.resolve(updatedMemberLanguages);
  } catch (error) {
    return Promise.reject(error);
  }
}

/**
 * Create Member applcation
 * @param {object} payload - memberId: member id // address: member address // utm: utm
 */
// eslint-disable-next-line
export async function createMemberApplication({ commit }, { payload }) {
  const createdMemberApplication = await OperatorApplicationAPI.createMemberApplication(payload);
  try {
    return Promise.resolve(createdMemberApplication);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function setStep({ commit }, payload) {
  try {
    if (payload) {
      commit(SET_STEP, payload);
    }
    return Promise.resolve(true);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function setMemberAddress({ commit }, payload) {
  try {
    if (payload) {
      commit(SET_ADDRESS, payload);
    }
    return Promise.resolve(true);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function setMemberPhone({ commit }, payload) {
  try {
    if (payload) {
      commit(SET_PHONE_NUMBER, payload);
    }
    return Promise.resolve(true);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function setMemberSkills({ commit }, payload) {
  try {
    if (payload) {
      commit(SET_SKILLS, payload);
    }
    return Promise.resolve(true);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function setMemberEquipment({ commit }, payload) {
  try {
    if (payload) {
      commit(SET_MEMBER_EQUIPMENTS, payload);
    }
    return Promise.resolve(true);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function setMemberProfile({ commit }, payload) {
  try {
    if (payload) {
      commit(SET_MEMBER_PROFILE, payload);
    }
    return Promise.resolve(true);
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function clearOnboardingStoreData({ commit }) {
  try {
    commit(SET_STEP, 1);
    commit(SET_ADDRESS, null);
    commit(SET_PHONE_NUMBER, null);
    commit(SET_SKILLS, []);
    commit(SET_MEMBER_EQUIPMENTS, []);
    commit(SET_MEMBER_PROFILE, null);
    return Promise.resolve(true);
  } catch (error) {
    return Promise.reject(error);
  }
}
